import { collection, doc, addDoc, updateDoc, getDocs, query, where, orderBy, limit } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { CashSession } from '../types';

export const cashService = {
  async getActiveSession(clubId: string): Promise<CashSession | null> {
    console.log("DEBUG: getActiveSession called with clubId:", clubId);
    try {
      const q = query(
        collection(db, 'cash_sessions'),
        where('clubId', '==', clubId),
        where('status', '==', 'open')
      );
      const snap = await getDocs(q);
      if (snap.empty) {
        if (typeof window !== 'undefined' && !window.navigator.onLine) {
          const cached = window.localStorage.getItem(`cached_active_session_${clubId}`);
          return cached ? JSON.parse(cached) : null;
        }
        if (typeof window !== 'undefined') {
          window.localStorage.removeItem(`cached_active_session_${clubId}`);
        }
        return null;
      }
      const docSnap = snap.docs[0];
      const sess = { id: docSnap.id, ...docSnap.data() } as CashSession;
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(`cached_active_session_${clubId}`, JSON.stringify(sess));
      }
      return sess;
    } catch (error) {
      console.error("Error fetching active cash session:", error);
      if (typeof window !== 'undefined') {
        const cached = window.localStorage.getItem(`cached_active_session_${clubId}`);
        return cached ? JSON.parse(cached) : null;
      }
      return null;
    }
  },

  async getSessionsHistory(clubId: string, limitCount = 50): Promise<CashSession[]> {
    try {
      const q = query(
        collection(db, 'cash_sessions'),
        where('clubId', '==', clubId),
        orderBy('openedAt', 'desc'),
        limit(limitCount)
      );
      const snap = await getDocs(q);
      if (snap.empty && typeof window !== 'undefined' && !window.navigator.onLine) {
        const cached = window.localStorage.getItem(`cached_sessions_history_${clubId}`);
        return cached ? JSON.parse(cached) : [];
      }
      const list = snap.docs.map(d => ({ id: d.id, ...d.data() } as CashSession));
      if (typeof window !== 'undefined' && (!snap.empty || window.navigator.onLine)) {
        window.localStorage.setItem(`cached_sessions_history_${clubId}`, JSON.stringify(list));
      }
      return list;
    } catch (error) {
      console.error("Error fetching cash sessions history:", error);
      if (typeof window !== 'undefined') {
        const cached = window.localStorage.getItem(`cached_sessions_history_${clubId}`);
        return cached ? JSON.parse(cached) : [];
      }
      return [];
    }
  },

  async openSession(session: Omit<CashSession, 'id'>): Promise<string> {
    const ref = await addDoc(collection(db, 'cash_sessions'), session);
    return ref.id;
  },

  async closeSession(sessionId: string, data: Partial<CashSession>): Promise<void> {
    const ref = doc(db, 'cash_sessions', sessionId);
    await updateDoc(ref, data);
  }
};
